import { render } from "./OnDemandBookingTelehealthIos.vue?vue&type=template&id=e99fa212&ts=true"
import script from "./OnDemandBookingTelehealthIos.vue?vue&type=script&lang=ts"
export * from "./OnDemandBookingTelehealthIos.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__